<template>
  <div>
    <section class="cart-section" style="padding:30px 0px;">
      <div class="container">
        <div class="">
          <div class="container padding-cls" style="margin-bottom:0px">
            <div class="checkout-page">
              <div class="checkout-form theme-form">
                <div class="row center-content">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <div class="theme-card check-out ng-star-inserted">
                      <div>
                        <div class="form-grou col-md-12 col-sm-12 col-xs-12" style="margin-bottom:25px">
                          <div class="field-label" style="line-height:24px;margin-bottom:10px;padding-left: 5px;" >Applied Unit/Subunit</div>
                          <!-- <div class="form-check form-check-inline" v-for="application in applications" :key="application.id">
                            <input v-if="application.status=='paid'" class="unit-card" v-model="seatPlan.unit" style="margin-top:.25em" type="radio" name="unit" :id="'unit'+application.unit" :value="application.unit" @change="getUnitValues">
 <div class="unit-card-content">
                            <div class="unit-label">{{application.unit}}</div>
                            </div>
                          </div> -->

                          <div class="unit-selection-grid">
                            <div
                              v-for="application in applications"
                              :key="application.id"
                              v-if="application.status == 'paid'"
                              class="unit-card"
                              :class="{
                                'unit-card-selected': seatPlan.unit === application.unit,
                                'unit-card-eligible': true
                              }"
                              @click="seatPlan.unit = application.unit; getUnitValues()"
                            >

                              <input
                                class="unit-radio-hidden"
                                v-model="seatPlan.unit"
                                type="radio"
                                name="unit"
                                :id="'unit'+application.unit"
                                :value="application.unit"
                                @change="getUnitValues"
                              >

                              <div class="unit-card-content">
                                <div class="unit-check-indicator">
                                  <i v-if="seatPlan.unit === application.unit" class="fa fa-check-circle"></i>
                                  <i v-else class="fa fa-circle-o"></i>
                                </div>

                                <div class="unit-label">
                                  {{ application.unit }}
                                </div>
                              </div>

                            </div>
                          </div>

                        </div>
                        <div class="middle-center" v-if="onSeatPlanLoading">
                          <global-spinner :animation-duration="1500" :size="50" color="#2196f3" />
                        </div>
                        <div v-else class="form-group col-md-12 col-sm-12 col-xs-12">
                          <div class="card" v-if="seatPlan.unit && seatPlan.message==''" style="margin-bottom:10px">
                            <div class="card-header bg-dark text-white" style="font-weight:boldx"><div class="row">
                              <div class="col-md-6" style="font-weight:bold">Seat Plan</div>
                              <div class="col-md-6" style="text-align:right;"><i>
                                Unit: {{seatPlan.unit}}<span style="margin-left: 10px;">Roll No: {{seatPlan.roll}}</span>
                              </i></div>
                            </div></div>
                            <div class="card-body table-responsive">
                              <table class="table" style="font-weight: bold;margin:auto">
                                <tr>
                                  <td class="count-desc">Center</td>
                                  <td class="count-desc">:</td>
                                  <td class="count-desc">
                                      {{seatPlan.center}}, {{seatPlan.region}}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="count-desc">Building</td>
                                  <td class="count-desc">:</td>
                                  <td class="count-desc">
                                      {{seatPlan.building}}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="count-desc">Room</td>
                                  <td class="count-desc">:</td>
                                  <td class="count-desc">
                                      {{seatPlan.room}}
                                  </td>
                                </tr>
                                <!--tr>
                                  <td class="count-desc">Shift</td>
                                  <td class="count-desc">:</td>
                                  <td class="count-desc">
                                      {{seatPlan.shift }}
                                  </td>
                                </tr-->
                                <tr>
                                  <td class="count-desc">Date</td>
                                  <td class="count-desc">:</td>
                                  <td class="count-desc">
                                      {{seatPlan.date}}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="count-desc">Time</td>
                                  <td class="count-desc">:</td>
                                  <td class="count-desc">
                                      {{seatPlan.time}}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                          <div v-if="seatPlan.unit && seatPlan.message!=''" style="margin-bottom:10px">
                            <span style="margin-left: 20px; text-transform: uppercasex; color:RED;">{{seatPlan.message}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Loader from '../Helper/Loader'
import { GET_SEAT_PLAN } from '../../const/api'
import { GET } from '../../utils/Request'

export default {
  name: 'ProfileSeatPlan',
  components: { Loader },
  props: ['applications'],
  data() {
    return {
        onSeatPlanLoading: true,
        firstTimeLoad: false,
        units:[],
        unitObj:{
          A:{
            center:'A Center',
            building:'A Building',
            room:'A Room',
            shift:'A Shift',
            date:'12 A',
            time:'12Am'
          },
          B:{
            center:'B Center',
            building:'B Building',
            room:'B Room',
            shift:'B Shift',
            date:'12 B',
            time:'12Bm'
          },
          C:{
            center:'C Center',
            building:'C Building',
            room:'C Room',
            shift:'C Shift',
            date:'12 C',
            time:'12Cm'
          }
        },
        seatPlan:{
          roll:'',
          unit:'',
          region:'',
          center:'',
          building:'',
          room:'',
          shift:'',
          date:'',
          time:'',
          message:''
        }
    }
  },
  created() {
    //console.log("ProfileSeatPlan::props['applications']=>", this.applications);
    for(let i=0;i<this.applications.length;++i){
      if(this.applications[i].status=='paid'){
        this.units.push(this.applications[i].unit);
      }
    }
    this.onSeatPlanLoading = false;
    // this.getUnitValues();
  },
  
  methods: {   
    convert12HFormat(time){
      let times = time.split(":")
      let hour = parseInt(time);
      let ampm = ' AM';

      if(hour>11){
        ampm = ' PM'
        if(hour!=12){
          hour -= 12;
        }
      } else if(hour==0){
        hour = 12;
      }
      if(times.length>1){
        return hour+':'+times[1]+ampm;
      }else{
        return hour+ampm;
      }
    },

    async getUnitValues(){
      
      this.onSeatPlanLoading = true;
      if(this.firstTimeLoad){
        if(this.units.length>0)
          this.seatPlan.unit = this.units[0];
      }

      var data = await GET(GET_SEAT_PLAN+this.seatPlan.unit);
      if(data.data.status=='success'){
        this.seatPlan.roll = data.data.application.exam_roll;
        this.seatPlan.region = data.data.data.exam_center_name;
        this.seatPlan.center = data.data.data.centre_name;
        this.seatPlan.building = data.data.data.building;
        this.seatPlan.room = data.data.data.room;
        this.seatPlan.shift = data.data.data.shift;
        this.seatPlan.date = data.data.data.date;
        this.seatPlan.time = data.data.data.start_time;
        /*if(data.data.data.start_time){
          this.seatPlan.time = this.convert12HFormat(data.data.data.start_time);
          if(data.data.data.end_time){
            this.seatPlan.time += ' - ' + this.convert12HFormat(data.data.data.end_time);
          }
        }else{
          this.seatPlan.time = '';
        }*/
        this.seatPlan.message = '';
      }else{
        this.seatPlan.roll = '';
        this.seatPlan.center = '';
        this.seatPlan.building = '';
        this.seatPlan.room = '';
        this.seatPlan.shift = '';
        this.seatPlan.date = '';
        this.seatPlan.time = '';
        if(data.data.message){
          /*this.$iziToast.error({
            //title: 'Admit Card',
            message: data.data.message
          });*/
          this.seatPlan.message = data.data.message;
        }
        else
          this.seatPlan.message = '';
      }
      
      this.onSeatPlanLoading = false;
      this.firstTimeLoad = false;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Container: Flexbox with wrapping and centered last row */
.unit-selection-grid, .quota-selection-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 15px;           /* spacing between cards */
  padding: 5px 5px;
  justify-content: flex-start;  /* center all rows including last row */
  overflow: visible;        /* ensure hover shadows are visible */
}

/* Unit Card Styling - Fixed size */
.unit-card {
  position: relative;
  z-index: 1;                 /* ensure hover shadows appear above others */
  background: #ffffff;
  border: 2px solid #e0e7ff;
  border-radius: 12px;
  padding: 10px 15px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: center;
  min-height: 80px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 120px;    /* FIXED width */
  flex: 0 0 auto;  /* prevent stretching */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

/* Hover Effect */
.unit-card:hover {
  transform: translateY(-3px) translateZ(0); /* ensure smooth hover */
  box-shadow: 0 8px 16px rgba(99, 102, 241, 0.15);
  border-color: #a5b4fc;
}

/* Eligible Unit */
.unit-card-eligible {
  border-color: #e0e7ff;
  background: linear-gradient(135deg, #ffffff 0%, #f8faff 100%);
}

.unit-card-eligible:hover {
  border-color: #818cf8;
}

/* Selected Unit */
.unit-card-selected {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  border-color: #4f46e5;
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.4);
}

.unit-card-selected:hover {
  transform: translateY(-3px) translateZ(0);
  box-shadow: 0 12px 24px rgba(99, 102, 241, 0.5);
}

.unit-card-selected .unit-label {
  color: #ffffff;
  font-weight: 700;
}

.unit-card-selected .unit-check-indicator i {
  color: #ffffff;
}

/* Ineligible Unit */
.unit-card-ineligible {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-color: #fecaca;
  opacity: 0.75;
  cursor: not-allowed;
}

.unit-card-ineligible:hover {
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  border-color: #fecaca;
}

.unit-card-ineligible .unit-label {
  color: #991b1b;
}

/* Hide the actual radio input */
.unit-radio-hidden {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

/* Unit Card Content */
.unit-card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  width: 100%;
}

/* Check Indicator */
.unit-check-indicator {
  font-size: 24px;
  margin-bottom: 5px;
}

.unit-check-indicator i {
  color: #6366f1;
  transition: all 0.3s ease;
}

.unit-card:hover .unit-check-indicator i {
  transform: scale(1.1);
}

/* Unit Label */
.unit-label {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

/* Status Badge for Ineligible Units */
.unit-status-badge {
  font-size: 11px;
  font-weight: 600;
  color: #dc2626;
  background: #ffffff;
  padding: 4px 10px;
  border-radius: 12px;
  margin-top: 5px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.15);
}

.unit-status-badge i {
  font-size: 12px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .unit-card {
    width: 100px;
    min-height: 100px;
  }
}

@media (max-width: 480px) {
  .unit-card {
    width: 90px;
    min-height: 90px;
    padding: 12px 10px;
  }

  .unit-label {
    font-size: 16px;
  }

  .unit-check-indicator {
    font-size: 20px;
  }
}

/* Input fix */
.theme-form input[type="text"] {
  min-width: 100% !important;
}
.loader {
  margin-top: 20%;
}
.d-flex{
  padding:10px;
  margin:10px;
  -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
    box-shadow: 1px 0 15px 2px #c1b3b3;
}
.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid{
  max-width:100%;
}


/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
   box-sizing: border-box;
}
.flower-spinner{
  margin: auto;
}

</style>